import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';

const InchestoMeters = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

    const convertInchesToMeters = () => {
    // Validate input: allow numbers, decimals, and optional minus sign
    if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
        setErrorMessage("Please enter a valid length in inches (e.g., 39.37, 100.5).");
        setOutputValue("");
        return;
    }

    setErrorMessage("");
    const inchValue = parseFloat(inputValue); // Convert input string to a number
    const meterValue = inchValue * 0.0254; // 1 inch = 0.0254 meters
    setOutputValue(meterValue.toFixed(6)); // Limit output to 6 decimal places
};

      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/meters-to-inches");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>Inches to Meters Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert inches to meters using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
                  <TitleSection
                    icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
                    title="Inches To Meters Converter"
                    subTitle="Effortlessly Convert Inches To Meters for Accurate Measurements"
                  />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>Inches Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter inches value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertInchesToMeters}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Meters Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={classes.contentContainer}>
      
     </div>
    </div>
   </div>
  )
}

export default InchestoMeters;
